import { render } from "./FormCascader.vue?vue&type=template&id=8668f8a0"
import script from "./FormCascader.vue?vue&type=script&lang=js"
export * from "./FormCascader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__